import LinearProgress from '@mui/material/LinearProgress';

import logo from '../../../images/logologin.png';

/**
 * The wait between submitting the login form and the account data landing.
 *
 * It used to be a bare `<CircularProgress />` returned in place of the page —
 * no layout around it, so the ring sat in the top-left corner of an otherwise
 * blank screen. This fills the viewport instead: the same logo the login card
 * carries, centred, over an indeterminate bar in the brand colour.
 *
 * The colour is read from the `--primary` token rather than written out, so it
 * follows the theme the buttons already use.
 */
function AuthLoading({ label = 'Loading' }: any) {
    return (
        <div className='flex h-screen w-full flex-col items-center justify-center gap-10 bg-white'>
            <img src={logo} alt='' className='w-[220px] max-w-[60vw]' />
            <LinearProgress
                aria-label={label}
                sx={{
                    width: 'min(280px, 60vw)',
                    height: 6,
                    borderRadius: 999,
                    backgroundColor: 'color-mix(in srgb, var(--primary) 18%, transparent)',
                    '& .MuiLinearProgress-bar': {
                        backgroundColor: 'var(--primary)',
                    },
                }}
            />
        </div>
    );
}

export default AuthLoading;
